import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Grid } from '../../app/StyleGuide';

// ---------------------------------------------------------------------------
// Actions
// ---------------------------------------------------------------------------

const StyledActions = styled.div`
  align-self: start;
`;

export function Actions(props: React.HTMLAttributes<HTMLDivElement>) {
  return <StyledActions {...props} />;
}

// ---------------------------------------------------------------------------
// Body
// ---------------------------------------------------------------------------

const StyledBody = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  padding: ${Grid._4};
  gap: ${Grid._4};

  &:has(${StyledActions}) h4 {
    padding-right: ${Grid._10};
  }

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    grid-template-columns: 300px 1fr auto;
  }
`;

export function Body(props: React.HTMLAttributes<HTMLDivElement>) {
  return <StyledBody {...props} />;
}

// ---------------------------------------------------------------------------
// Content
// ---------------------------------------------------------------------------

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export function Content(props: React.HTMLAttributes<HTMLDivElement>) {
  return <StyledContent {...props} />;
}
